import { render, staticRenderFns } from "./LocalPriceSourcesGrid.vue?vue&type=template&id=297505a4"
import script from "./LocalPriceSourcesGrid.vue?vue&type=script&lang=js"
export * from "./LocalPriceSourcesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports